import { useNavigate, useParams } from "react-router-dom";

import { useCreateToolRegistry } from "@/queries/tool-registry";
import { ToastType } from "@/enums";
import { displayToast } from "@/utils/toast";

const DEFAULT_TOOL_DEFINITION = {
  type: "function",
  function: {
    name: "my_function",
    description: "",
    parameters: {
      type: "object",
      properties: {},
      required: [],
      additionalProperties: false,
    },
    strict: false,
  },
};

const useCreateDefaultTool = (folderId: number | null = null, openInNewTab = false) => {
  const { workspaceId } = useParams();
  const navigate = useNavigate();
  const workspaceIdNumber = workspaceId ? Number(workspaceId) : null;

  const createMutation = useCreateToolRegistry({
    onSuccess: data => {
      displayToast("Tool created successfully", ToastType.success);
      const url = `/workspace/${workspaceId}/tool/${data.tool_registry.id}/version/1/edit`;
      if (openInNewTab) {
        window.open(url, "_blank");
      } else {
        navigate(url);
      }
    },
  });

  const create = async () => {
    if (!workspaceIdNumber) {
      return;
    }

    try {
      await createMutation.mutateAsync({
        workspaceId: workspaceIdNumber,
        folderId: folderId ?? undefined,
        toolDefinition: DEFAULT_TOOL_DEFINITION,
        commitMessage: "Initial version",
      });
    } catch {
      // Error handling is already centralized in the mutation hook.
    }
  };

  return {
    create,
    isCreating: createMutation.isPending,
  };
};

export default useCreateDefaultTool;
